import { useTranslation } from 'react-i18next';
import { SystemBar, SystemBarEnvironment } from '@c2fo/liquidity';
import { getEnvName } from '@/utils/env';
import logout from '@/utils/logout';
import { getTokenContent } from '@/utils/token';

// getEnvName() returns the raw VITE_ENV value (fss | uat | prod | demo), which doesn't
// line up 1:1 with SystemBar's fixed environment union.
function toSystemBarEnvironment(envName: string): SystemBarEnvironment {
  if (envName.startsWith('prod')) return 'production';
  if (envName === 'uat') return 'uat';
  return 'fss';
}

export const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation();
  const content = getTokenContent();
  const impersonator = content?.payload.user.emailAddress || '';
  const subject = content?.payload.impersonationSubject?.emailAddress || '';
  const impersonationMessage = t('impersonation.bannerMessage', { impersonator, subject });

  return (
    <SystemBar
      variant="impersonation"
      environment={toSystemBarEnvironment(getEnvName())}
      label={impersonationMessage}
      exitLabel={t('impersonation.exitButton')}
      onExitImpersonation={logout}
    />
  );
};
